<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { toastBus, type Toast } from '../utils/toast';

const toasts = ref<Toast[]>([]);

function onPush(t: Toast): void {
  toasts.value.push(t);
  setTimeout(() => {
    toasts.value = toasts.value.filter((x) => x.id !== t.id);
  }, t.durationMs);
}

onMounted(() => toastBus.on(onPush));
onUnmounted(() => toastBus.off(onPush));
</script>

<template>
  <div
    class="fixed inset-x-0 top-3 z-50 flex flex-col items-center gap-2 px-4 pointer-events-none safe-top"
  >
    <TransitionGroup name="fade">
      <div
        v-for="t in toasts"
        :key="t.id"
        class="card-elevated px-4 py-3 max-w-md w-full text-sm pointer-events-auto"
        :class="{
          'border-danger/40 bg-danger-bg/80 text-danger-fg': t.kind === 'error',
          'border-success/40 bg-success/15 text-success-fg': t.kind === 'success',
        }"
      >
        {{ t.message }}
      </div>
    </TransitionGroup>
  </div>
</template>
